module.exports = __webpack_public_path__ + "img/neta_header_mask.ea70d28a.png";